//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { LocalizationInfo } from './LocalizationInfo';
import { SchoolAccountingSettingsDisplayItem } from './SchoolAccountingSettingsDisplayItem';
import { SchoolEmailSettingsDisplayItem } from './SchoolEmailSettingsDisplayItem';
import { SchoolEventPolicySettingsDisplayItem } from './SchoolEventPolicySettingsDisplayItem';
import { SchoolInvoiceSettingsDisplayItem } from './SchoolInvoiceSettingsDisplayItem';
import { SchoolMembershipDisplayItem } from './SchoolMembershipDisplayItem';
import { SchoolPaymentSettingsDisplayItem } from './SchoolPaymentSettingsDisplayItem';
import { SchoolStudentPortalSettingsDisplayItem } from './SchoolStudentPortalSettingsDisplayItem';
import { SchoolSMSProviderDisplayItem } from './SchoolSMSProviderDisplayItem';
import { SocialMediaLinkDisplayItem } from './SocialMediaLinkDisplayItem';
import { NameFormat } from './Enums';

export class SchoolDisplayItem extends ItemBase {
    ID: string | null = null;
    EnableCalendarConflicts: boolean = false;
    IsMultiTeacher: boolean = false;
    Locale: string | null = null;
    LocalizationInfo: LocalizationInfo | null = null;
    Name: string | null = null;
    ParentNameFormat: NameFormat = NameFormat.LastCommaFirst;
    PhoneNumber: string | null = null;
    ShowNotSpecifiedEventLocation: boolean = false;
    ShowAPI: boolean = false;
    StudentNameFormat: NameFormat = NameFormat.LastCommaFirst;
    TeacherNameFormat: NameFormat = NameFormat.LastCommaFirst;
    TimeZoneID: string | null = null;
    CurrentUTCOffsetMinutes: number = 0;
    Country: string | null = null;
    HasBlog: boolean = false;
    MaximumProfileImageSizeInBytes: number = 0;
    MinimumPasswordLength: number = 0;
    TrialStartDate: string = "1970-01-01T00:00:00";
    TrialEndDate: string = "1970-01-01T00:00:00";
    AccountingSettings: SchoolAccountingSettingsDisplayItem | null = null;
    EmailSettings: SchoolEmailSettingsDisplayItem | null = null;
    EventPolicySettings: SchoolEventPolicySettingsDisplayItem | null = null;
    InvoiceSettings: SchoolInvoiceSettingsDisplayItem | null = null;
    Membership: SchoolMembershipDisplayItem | null = null;
    OnlinePaymentSettings: SchoolPaymentSettingsDisplayItem | null = null;
    StudentPortalSettings: SchoolStudentPortalSettingsDisplayItem | null = null;
    CanSetTimeZone: boolean = false;
    SMSProvider: SchoolSMSProviderDisplayItem | null = null;
    PackagesActive: boolean = false;
    SocialLinks: SocialMediaLinkDisplayItem[] = [];
    GoogleReviewsLink: string | null = null;
    Latitude: number | null = null;
    Longitude: number | null = null;

    constructor(initializer?: Partial<SchoolDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolDisplayItem";
}
